import Box from '../Box/Box';
import { Head3, Head6, Headline } from '../Typography/Typography';
import { rem } from 'polished';
import { gridGap } from '../Grid/Grid';
import React from 'react';
import useViewport from '../../hooks/useViewport';
import { NoSearchResults } from '../NoSearchResults/NoSearchResults';
// @ts-ignore

export const CardListItems = ({
    items,
    activeTab,
    renderItem,
    gridTemplateColumns,
}) => {
    const { isMobile } = useViewport();

    return (
        <Box>
            <Box
                as={isMobile ? Head3 : Head6}
                marginBottom={{ _: rem(20), md: rem(32) }}
            >
                {activeTab}
            </Box>

            {items.length ? (
                <Box
                    display="grid"
                    gridTemplateColumns={gridTemplateColumns}
                    gridAutoRows={`minmax(${rem(256)}, auto);`}
                    gridGap={gridGap}
                >
                    {items.map(renderItem)}
                </Box>
            ) : (
                <Box textAlign="center" marginTop={rem(80)}>
                    <NoSearchResults />
                </Box>
            )}
        </Box>
    );
};
